/**
 * * @module view/gallery.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";
import Bootstrap from "bootstrap";

const Navigation = Backbone.View.extend({
  el: $(document),

  events: {
    "click .burger-button": "manageNavigation",
    "click .navigation-header .close-button": "closeNav",
    "click .support-charity": "managePullOut",
    "click .pull-out .pull-out-close-button": "closePullOutMobile",
    "click .action-buttons .icon-search": "toggleSearch",
    "click .search-form-wrapper .close-button": "toggleSearch"
  },

  windowWidth: "",

  nav: "",

  scrollValue: undefined,

  initialize: function () {
    this.render();
  },

  manageNavigation: function (e) {
    const _this = this;
    const $nav = $(_this.nav);

    const $pullOut = $(".pull-out");
    if ($pullOut.hasClass("open")) {
      _this.managePullOut();
    }

    $nav.animate({ right: 0 }, 350);
    $nav.addClass("open").css('display', 'block');
    if ($(window).width() < 769) {
      $nav.css("display", "block");
      $('body').addClass('navIsOpen');
    }
  },


  checkScroll: function () {
    var _this = this;
    // const headerHeight = $(".header").innerHeight();
    const isHomepage = $('body').hasClass('home');

    // if (!isHomepage) {
    //   return;
    // }
    
    const $header = $(".header");
    const $logo = $("#logo");
    const $logoColour = $("#logo-colour");

    const headerHeight = $header.height();

    $(window).scroll(function () {

      if ($(window).scrollTop() < _this.scrollValue) {

        $header.addClass('scrolled');
        $("body").addClass("scrolled");
        if (isHomepage) {
          $logo.css('display', 'none');
          $logoColour.css('display', 'block');
        }
        $header.css("top", "0");
        _this.scrollValue = $(window).scrollTop();

      } else {
        $header.removeClass('scrolled');
        $("body").removeClass("scrolled");
        if (isHomepage) {
          $logo.css('display', 'block');
          $logoColour.css('display', 'none');
        }

        if (_this.scrollValue > headerHeight) {
          $header.css({
            "top" : "-" + headerHeight + "px"
          });
          if ($(window).width() >= 769) {
            $('.navigation-container').css('top', headerHeight + 'px');
          }
        }
        _this.scrollValue = $(window).scrollTop();
      }


      // disabled because user won't be able to scroll to bottom links
      // // close nav if we scroll beyond the nav
      // if ($(window).scrollTop() >= 91) {
      //   if ($(".navigation-container").hasClass('open')){
      //     _this.closeNav();
      //   }
      // }
    });
  },

  closeNav: function () {
    const _this = this;
    const $nav = _this.nav;

    if ($(window).width() < 769) {
      $nav.animate({ right: "-" + _this.windowWidth + "px" }, 350);
      $nav.removeClass("open").css("display", "none");
    } else {
      $nav.animate({ right: "-" + (_this.nav.width() + 1 ) + "px" }, 350);
      if ($(".pull-out").hasClass("open")) {
        _this.closePullOutMobile();
      }
    }
  },

  managePullOut: function () {
    if ($(window).width() >= 769) {
      const $pullOut = $(".pull-out");
      const pullOutInnerWidth = $(".pull-out-inner").width();

      if ($pullOut.hasClass("open")) {
        $pullOut.animate({ right: "-" + pullOutInnerWidth + "px" }, 350);
        $pullOut.removeClass("open");
      } else {
        $pullOut.animate({ right: "0px" }, 350);
        $pullOut.addClass("open");
      }
    }
  },

  closePullOutMobile: function () {
    $(".pull-out").css("display", "none");
  },

  prepareNavAndPullOut: function () {
    const _this = this;
    const $secondaryNav = $(".secondary-nav-secondary-level");

    _this.windowWidth = $("body").innerWidth();
    _this.nav = $(".navigation-container");

    if ($(window).width() < 769) {
      $(_this.nav).css({"right": "-" + _this.windowWidth + "px", "display": "none"});
    } else {
      $(_this.nav).css("right", "-" + (_this.nav.width()+1) + "px");
    }

    $(document).click(function (e) {
      const target = $(e.target).parent();

      // console.log($(e.target).attr("class"));

      // it's not a click on nav items
      if ($(target).closest(".navigation-container").length == 0) {
        if (
          !target.hasClass("burger-button") &&
          !target.hasClass("action-buttons") &&
          !$(e.target).hasClass("support-charity") && //desktop
          !$(e.target).hasClass("pull-out-close-button") && //mobile
          !target.hasClass("pull-out-close-button") && //mobile
          $(_this.nav).hasClass('open')
        ) {
          //it's not the nav open button
          _this.closeNav();

          console.log("not a navigation item but still a clickable item");
        }
      } else {
        if ($(e.target).hasClass("support")) {
          $(".pull-out").css("display", "block");
        }
      }
    });

    $secondaryNav.on("show.bs.collapse", function (e) {
      $(e.target).prev().addClass("open");
    });

    $secondaryNav.on("hide.bs.collapse", function (e) {
      $(e.target).prev().removeClass("open");
    });

    //PULL-OUT
    if ($(window).width() >= 769) {
      const $pullOut = $(".pull-out");
      const pullOutHeight = $pullOut.height();
      // const pullOutWidth = $('.pull-out-inner').width();
      const $button = $(".support-charity");

      $button.width(pullOutHeight - (49 * 2) + "px");
      // $pullOut.css("right", "-" + pullOutWidth + "px");
    }
  },

  toggleSearch: function(){
    const $searchFormWrapper = $('.search-form-outer');

    if ($searchFormWrapper.hasClass('open')){
      $searchFormWrapper.slideUp().removeClass('open');
    }else{
      $searchFormWrapper.slideDown().addClass('open');
    }
  },

  render: function () {
    this.prepareNavAndPullOut();
    this.checkScroll();
  },
});

export default Navigation;
